import React from 'react';
import Layout from '../components/Layout';
import Main from '../components/Main';

function Home() {
  return (
    <Layout>
      <Main />
    </Layout>
  );
}

export default Home;
